// @TODO: Переезд на Pinia; особое внимание к этому файлу

import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'
import { useTranslaterStore } from './translater'
import getRequestParams from '@/helpers/getRequestParams'
import parseMinutes from '@/helpers/parseMinutes'

export const usePointsStore = defineStore('points', () => {
    const configStore = useConfigStore()
    const requestsStore = useRequestsStore()
    const tokenStore = useTokenStore()
    const translaterStore = useTranslaterStore()

    const getTranslate = computed(() => translaterStore.getTranslate)

    const point = ref(null)

    const cars = ref({})

    const carState = ref({
        door_trunk: {
            value: null,
            value_text: '',
            unit: '',
            id: 13
        },
        engine_on: {
            value: null,
            value_text: '',
            unit: '',
            id: 43
        },
        engine_off: {
            value: null,
            value_text: '',
            unit: '',
            id: 44
        },
        start_moving: {
            value: null,
            value_text: '',
            unit: '',
            id: 45
        },
        stop_moving: {
            value: null,
            value_text: '',
            unit: '',
            id: 46
        },
        ride_time: {
            value: null,
            value_text: '',
            unit: 'UNIT_SECOND',
            id: 34
        },
        sdm_uptime: {
            value: null,
            value_text: '',
            unit: 'UNIT_MINUTE',
            id: 128
        },
        wheel_front_left_pressure: {
            value: null,
            value_text: '',
            unit: 'UNIT_BAR',
            id: 22
        },
        wheel_front_right_pressure: {
            value: null,
            value_text: '',
            unit: 'UNIT_BAR',
            id: 23
        },
        wheel_back_left_pressure: {
            value: null,
            value_text: '',
            unit: 'UNIT_BAR',
            id: 24
        },
        wheel_back_right_pressure: {
            value: null,
            value_text: '',
            unit: 'UNIT_BAR',
            id: 25
        },
        wheel_front_left_status: {
            value: null,
            value_text: '',
            unit: '',
            id: 37
        },
        wheel_front_right_status: {
            value: null,
            value_text: '',
            unit: '',
            id: 38
        },
        wheel_back_left_status: {
            value: null,
            value_text: '',
            unit: '',
            id: 39
        },
        wheel_back_right_status: {
            value: null,
            value_text: '',
            unit: '',
            id: 40
        },
        door_front_left: {
            value: null,
            value_text: '',
            unit: '',
            id: 9
        },
        door_front_right: {
            value: null,
            value_text: '',
            unit: '',
            id: 10
        },
        door_back_left: {
            value: null,
            value_text: '',
            unit: '',
            id: 11
        },
        door_back_right: {
            value: null,
            value_text: '',
            unit: '',
            id: 12
        },
        service_date: {
            value: null,
            value_text: '',
            unit: '',
            id: 114
        },
        lvb_soh: {
            value: null,
            value_text: '',
            unit: '%',
            id: 126
        },
        lvb_soc: {
            value: null,
            value_text: '',
            unit: '%',
            id: 127
        },
        SOH_HV_AKB: {
            value: null,
            value_text: '',
            unit: '%',
            id: 135
        },
        SOC_HV_AKB: {
            value: null,
            value_text: '',
            unit: '%',
            id: 136
        },
        engine_oil_lvInd: {
            value: null,
            value_text: '',
            unit: '',
            id: 55
        },
        door_hood: {
            value: null,
            value_text: '',
            unit: '',
            id: 8
        },
        battery_voltage: {
            value: null,
            value_text: '',
            unit: 'UNIT_VOLT',
            id: 21
        },
        window_fully_closed_FL: {
            value: null,
            value_text: '',
            unit: '',
            id: 117
        },
        window_fully_closed_FR: {
            value: null,
            value_text: '',
            unit: '',
            id: 118
        },
        window_fully_closed_RL: {
            value: null,
            value_text: '',
            unit: '',
            id: 119
        },
        window_fully_closed_RR: {
            value: null,
            value_text: '',
            unit: '',
            id: 120
        },
        gear_position: {
            value: null,
            value_text: '',
            unit: '',
            id: 48
        },
        last_diagnostics_time: {
            value: null,
            value_text: '',
            unit: '',
            id: 52
        },
        last_navigation_time: {
            value: null,
            value_text: '',
            unit: '',
            id: 50
        },
        last_can_param_time: {
            value: null,
            value_text: '',
            unit: '',
            id: 51
        },
        last_online: {
            value: null,
            value_text: '',
            unit: '',
            id: 0
        },
        online: {
            value: null,
            value_text: '',
            unit: '',
            id: 0
        },
        total_mileage: {
            value: null,
            value_text: '',
            unit: 'UNIT_KM',
            id: 15
        },
        service_mileage: {
            value: null,
            value_text: '',
            unit: 'UNIT_KM',
            id: 115
        },
        ride_mileage: {
            value: null,
            value_text: '',
            unit: 'UNIT_KM',
            id: 31
        },
        status: {
            value: null,
            value_text: '',
            unit: '',
            id: 1
        },
        is_locked: {
            value: null,
            value_text: '',
            unit: '',
            id: 14
        },
        battery_status: {
            value: null,
            value_text: '',
            unit: '',
            id: 41
        },
        battery12VStatus: {
            value: null,
            value_text: '',
            unit: '',
            id: 41
        },
        TPMS_battery_status_FL: {
            value: null,
            value_text: '',
            unit: '',
            id: 96
        },
        TPMS_battery_status_FR: {
            value: null,
            value_text: '',
            unit: '',
            id: 97
        },
        TPMS_battery_status_RL: {
            value: null,
            value_text: '',
            unit: '',
            id: 98
        },
        TPMS_battery_status_RR: {
            value: null,
            value_text: '',
            unit: '',
            id: 99
        },
        vas_activation: {
            value: null,
            value_text: '',
            unit: '',
            id: 129
        },
        ride_fuel_consumption: {
            value: null,
            value_text: '',
            unit: 'UNIT_ML',
            id: 33
        },
        fuel_consumption: {
            value: null,
            value_text: '',
            unit: 'UNIT_LITER_100_KM',
            id: 18
        },
        fuel_level_percent: {
            value: null,
            value_text: '',
            unit: '%',
            id: 122
        },
        front_inside_temperature: {
            value: null,
            value_text: '',
            unit: '°C',
            id: 121
        },
        back_inside_temperature: {
            value: null,
            value_text: '',
            unit: '°C',
            id: 122
        },
        temperature_outside: {
            value: null,
            value_text: '',
            unit: '°C',
            id: 7
        },
        front_left_temperature: {
            value: null,
            value_text: '',
            unit: '°C',
            id: 3
        },
        front_right_temperature: {
            value: null,
            value_text: '',
            unit: '°C',
            id: 4
        },
        back_left_temperature: {
            value: null,
            value_text: '',
            unit: '°C',
            id: 5
        },
        back_right_temperature: {
            value: null,
            value_text: '',
            unit: '°C',
            id: 6
        },
        oil_level: {
            value: null,
            value_text: '',
            unit: '%',
            id: 56
        },
        washer_fluid: {
            value: null,
            value_text: '',
            unit: '',
            id: 35
        },
        coolant_fluid: {
            value: null,
            value_text: '',
            unit: '',
            id: 36
        },
        fuel: {
            value: null,
            value_text: '',
            unit: 'UNIT_LITER',
            id: 17
        },
        // engine_time: { // Моточасы
        //     value: null,
        //     value_text: '',
        //     unit: 'UNIT_HOUR',
        //     id: 130
        // },
        total_mileage_am: {
            value: null,
            value_text: '',
            unit: 'UNIT_KM',
            id: 131
        },
        total_avg_speed_am: {
            value: null,
            value_text: '',
            unit: 'UNIT_KMH',
            id: 132
        },
        total_mins_am: {
            value: null,
            value_text: '',
            unit: '',
            id: 133
        },
        cruising_range: {
            value: null,
            value_text: '',
            unit: 'UNIT_KM',
            id: 134
        },
        ocu_fl_stat: {
            value: null,
            value_text: '',
            unit: ''
        },
        ocu_fr_stat: {
            value: null,
            value_text: '',
            unit: ''
        },
        ocu_rl_stat: {
            value: null,
            value_text: '',
            unit: ''
        },
        ocu_rr_stat: {
            value: null,
            value_text: '',
            unit: ''
        },
        trip_acceleration: {
            value: null,
            value_text: '',
            unit: ''
        },
        trip_braking: {
            value: null,
            value_text: '',
            unit: ''
        },
        total_acceleration: {
            value: null,
            value_text: '',
            unit: ''
        },
        total_braking: {
            value: null,
            value_text: '',
            unit: ''
        },
        sat: {
            value: null,
            value_text: '',
            unit: ''
        },

        not_set: {
            value: null,
            value_text: '',
            unit: ''
        },
        mov: {
            value: null,
            value_text: '',
            unit: ''
        },
        received_signal_strength_indicator: {
            value: null,
            value_text: '',
            unit: 'dBm'
        },
        mobile_network_type_indicator: {
            value: null,
            value_text: '',
            unit: ''
        },
        alarm_system: {
            value: null,
            value_text: '',
            unit: ''
        },
        SRC: {
            value: null,
            value_text: '',
            unit: ''
        },
        ANS1: {
            value: null,
            value_text: '',
            unit: ''
        },
        ANS2: {
            value: null,
            value_text: '',
            unit: ''
        },
        ANS3: {
            value: null,
            value_text: '',
            unit: ''
        },
        ANS4: {
            value: null,
            value_text: '',
            unit: ''
        },
        ANS5: {
            value: null,
            value_text: '',
            unit: ''
        },
        DIG1: {
            value: null,
            value_text: '',
            unit: ''
        },
        DIG2: {
            value: null,
            value_text: '',
            unit: ''
        },
        DIG3: {
            value: null,
            value_text: '',
            unit: ''
        },
        DIG4: {
            value: null,
            value_text: '',
            unit: ''
        },
        DIG5: {
            value: null,
            value_text: '',
            unit: ''
        },
        CONN_TYPE: {
            value: null,
            value_text: '',
            unit: ''
        },
        coolant_temperature: {
            value: null,
            value_text: '',
            unit: '°C'
        },
        engine_oil_temperature: {
            value: null,
            value_text: '',
            unit: '°C'
        },
        network_rssi_bb: {
            value: null,
            value_text: 'dBm',
            unit: ''
        },
        network_type_bb: {
            value: null,
            value_text: '',
            unit: ''
        },
        spd: {
            value: null,
            value_text: '',
            unit: 'UNIT_KMH',
            id: 998
        },
        alt: {
            value: null,
            value_text: '',
            unit: 'UNIT_METRE',
            id: 999
        },
        energy_consumed: {
            value: null,
            value_text: '',
            unit: 'UNIT_KVH_100_KM'
        },
        trip_energy_consumed_w: {
            value: null,
            value_text: '',
            unit: 'UNIT_WATT',
            id: 990
        },
        comm_status: {
            value: null,
            value_text: '',
            unit: '',
            id: 991
        },
        ice_status: {
            value: null,
            value_text: '',
            unit: '',
            id: 993
        },
        hv_battery_soc_percent: {
            value: null,
            value_text: '',
            unit: '%',
            id: 992
        },
        charging_status: {
            value: null,
            value_text: '',
            unit: ''
        },
        charger_input_power_w: {
            value: null,
            value_text: '',
            unit: 'UNIT_WATT'
        },
        charger_input_current_ma: {
            value: null,
            value_text: '',
            unit: 'UNIT_MA'
        },
        charging_soc_limit_percent: {
            value: null,
            value_text: '',
            unit: '%'
        },
        reduce_charging_status: {
            value: null,
            value_text: '',
            unit: ''
        },
        remaining_charging_time_s: {
            value: null,
            value_text: '',
            unit: 'UNIT_S'
        },
        total_charging_power_wh: {
            value: null,
            value_text: '',
            unit: 'UNIT_WATT'
        },
        charging_duration_s: {
            value: null,
            value_text: '',
            unit: 'UNIT_SECOND_LONG'
        },
        ccu_type: {
            value: null,
            value_text: '',
            unit: ''
        },
        CAN_CCU_Stat1: {
            value: null,
            value_text: '',
            unit: ''
        },
        CAN_CCU_Stat2: {
            value: null,
            value_text: '',
            unit: ''
        },
        CAN_CCU_Stat3: {
            value: null,
            value_text: '',
            unit: ''
        },
        CAN_UMP10_CCU_Stat1: {
            value: null,
            value_text: '',
            unit: ''
        },
        CAN_UMP10_CCU_Stat2: {
            value: null,
            value_text: '',
            unit: ''
        },
        CAN_CCU_Stat1_Struct: {
            value: null,
            value_text: '',
            unit: ''
        },
        CAN_CCU_Stat2_Struct: {
            value: null,
            value_text: '',
            unit: ''
        },
        CAN_CCU_Stat3_Struct: {
            value: null,
            value_text: '',
            unit: ''
        },
        CAN_UMP10_CCU_Stat1_Struct: {
            value: null,
            value_text: '',
            unit: ''
        },
        CAN_UMP10_CCU_Stat2_Structs: {
            value: null,
            value_text: '',
            unit: ''
        }
    })

    const carStateMsg = ref('')

    const carOnline = ref({
        status: 0,
        text: 'OFFLINE'
    })

    const connectionType = ref({
        type: '',
        level: 0
    })

    const latestPoint = ref({})
    const latestPointProcess = ref(false)
    const latestPointMsg = ref({})

    async function readLatestPoint(payload) {
        const token = tokenStore.access
        let result = {}

        if (token) {
            latestPointProcess.value = true

            let params = getRequestParams(payload)

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars/points/latest${params}`,
                method: 'GET',
                token
            })

            if (!request.error) {
                // Ручная проверка актуальности carState
                // const swaggerArr = [
                //     "not_set",
                //     "status",
                //     "mov",
                //     "front_left_temperature",
                //     "front_right_temperature",
                //     "back_left_temperature",
                //     "back_right_temperature",
                //     "temperature_outside",
                //     "door_hood",
                //     "door_front_left",
                //     "door_front_right",
                //     "door_back_left",
                //     "door_back_right",
                //     "door_trunk",
                //     "is_locked",
                //     "fuel",
                //     "fuel_consumption",
                //     "battery_voltage",
                //     "wheel_front_left_pressure",
                //     "wheel_front_right_pressure",
                //     "wheel_back_left_pressure",
                //     "wheel_back_right_pressure",
                //     "ride_mileage",
                //     "ride_fuel_consumption",
                //     "ride_time",
                //     "washer_fluid",
                //     "coolant_fluid",
                //     "wheel_front_left_status",
                //     "wheel_front_right_status",
                //     "wheel_back_left_status",
                //     "wheel_back_right_status",
                //     "battery_status",
                //     "online",
                //     "engine_on",
                //     "engine_off",
                //     "start_moving",
                //     "stop_moving",
                //     "gear_position",
                //     "last_navigation_time",
                //     "last_can_param_time",
                //     "last_diagnostics_time",
                //     "engine_oil_lvInd",
                //     "oil_level",
                //     "TPMS_battery_status_FL",
                //     "TPMS_battery_status_FR",
                //     "TPMS_battery_status_RL",
                //     "TPMS_battery_status_RR",
                //     "service_date",
                //     "service_mileage",
                //     "sat",
                //     "window_fully_closed_FL",
                //     "window_fully_closed_FR",
                //     "window_fully_closed_RL",
                //     "window_fully_closed_RR",
                //     "front_inside_temperature",
                //     "back_inside_temperature",
                //     "received_signal_strength_indicator",
                //     "mobile_network_type_indicator",
                //     "alarm_system",
                //     "lvb_soh",
                //     "lvb_soc",
                //     "sdm_uptime",
                //     "vas_activation",
                //     "engine_time",
                //     "total_mileage_am",
                //     "total_avg_speed_am",
                //     "total_mins_am",
                //     "cruising_range",
                //     "SOH_HV_AKB",
                //     "SOC_HV_AKB",
                //     "ocu_fl_stat",
                //     "ocu_fr_stat",
                //     "ocu_rl_stat",
                //     "ocu_rr_stat",
                //     "SRC",
                //     "ANS1",
                //     "ANS2",
                //     "ANS3",
                //     "ANS4",
                //     "ANS5",
                //     "DIG1",
                //     "DIG2",
                //     "DIG3",
                //     "DIG4",
                //     "DIG5",
                //     "CONN_TYPE",
                //     "total_mileage",
                //     "trip_acceleration",
                //     "trip_braking",
                //     "total_acceleration",
                //     "total_braking"
                // ]
                // dispatch('checkCarStates', swaggerArr)

                request.array.map(point => {
                    point = point
                    readPoints(point)
                })

                result = request

                latestPointMsg.value = { success: true, text: '' }
            } else {
                latestPointMsg.value = { success: false }
                latestPointMsg.value.text = getTranslate[request.error] || request.error
            }

            latestPointProcess.value = false
        } else {
            latestPointMsg.value = { success: false, text: getTranslate.value.EUnauthRequest }
        }

        return result
    }

    async function readPoints(msg) {
        if (!cars.value[msg.car]) {
            cars.value[msg.car] = {}
        }

        // Стейты автомобиля
        const states = msg.s || []

        for (let carStateItem of states) {
            let value = '',
                value_text = ''

            if ('value' in carStateItem) {
                if ('d' in carStateItem.value) value = Number(carStateItem.value.d) // Целое число
                if ('i' in carStateItem.value) value = Number(carStateItem.value.i) // Число с плавающей точкой
                if ('s' in carStateItem.value) value = String(carStateItem.value.s) // Строка
                if ('o' in carStateItem.value) value = carStateItem.value.o // Объект; сложное значение стейта
            } else {
                if (
                    ![
                        'engine_on',
                        'engine_off',
                        'start_moving',
                        'stop_moving',
                        'last_diagnostics_time',
                        'last_navigation_time',
                        'last_can_param_time'
                    ].includes(carStateItem.key)
                ) {
                    value = 0
                }
            }

            if (carStateItem.valid === true) {
                switch (carStateItem.key) {
                    case 'high_beam_left_status':
                    case 'rear_fog_light_status':
                    case 'front_left_fog_light_status':
                    case 'front_right_fog_light_status':
                    case 'brake_light_left_status':
                    case 'brake_light_right_status':
                    case 'brake_light_HM_status':
                    case 'mil_onRq':
                    case 'mil_ind_blink':
                    case 'high_beam_right_status':
                    case 'low_beam_left_status':
                    case 'low_beam_right_status':
                    case 'reverse_light_left_status':
                    case 'reverse_light_right_status':
                    case 'position_light_RL_status':
                    case 'position_light_RR_status':
                    case 'cornering_light_left_status':
                    case 'cornering_light_right_status':
                    case 'daytime_light_left_status':
                    case 'daytime_light_right_status':
                    case 'turn_indicator_FL_status':
                    case 'turn_indicator_FR_status':
                    case 'turn_indicator_ML_status':
                    case 'turn_indicator_MR_status':
                    case 'turn_indicator_RL_status':
                    case 'turn_indicator_RR_status':
                    case 'position_light_FL_status':
                    case 'position_light_FR_status':
                    case 'head_light_leveling_ctrl_failure':
                    case 'SCU_fault_status':
                    case 'ABS_lamp':
                    case 'EBD_lamp':
                    case 'TCS_lamp':
                    case 'TPMS_sensor_fault_FL':
                    case 'TPMS_sensor_fault_FR':
                    case 'TPMS_sensor_fault_RL':
                    case 'TPMS_sensor_fault_RR':
                    case 'T15_fault_status':
                    case 'T30i_fault_status':
                    case 'T30d_fault_status':
                    case 'BCM_warning_indicator':
                    case 'DMFL_warning_indicator':
                    case 'DMFR_warning_indicator':
                    case 'DMRL_warning_indicator':
                    case 'DMRR_warning_indicator':
                    case 'ESP_lamp':
                    case 'TM_warning_indicator':
                        switch (value) {
                            case 0:
                                value = 'No failure'
                                break
                            case 1:
                                value = 'Failure'
                                break
                        }
                        break

                    case 'TPMS_battery_status_FL':
                    case 'TPMS_battery_status_FR':
                    case 'TPMS_battery_status_RL':
                    case 'TPMS_battery_status_RR':
                        switch (value) {
                            case 0:
                                value_text = 'STATE_TPMS_BATTERY_NORMAL'
                                break
                            case 1:
                                value_text = 'STATE_TPMS_BATTERY_LOW'
                                break
                        }
                        break

                    case 'SCU_calibration_status':
                        switch (value) {
                            case 0:
                                value = 'Calibrated'
                                break
                            case 1:
                                value = 'Uncalibrated'
                                break
                        }
                        break

                    case 'CCU_failure':
                        switch (value) {
                            case 0x0:
                                value = 'No Failure'
                                break
                            case 0x1:
                                value = 'Full Failure'
                                break
                            case 0x2:
                                value = 'Failure in front zone'
                                break
                            case 0x3:
                                value = 'Failure in rear zone'
                                break
                            case 0x4:
                                value = 'Failure with pressure in the circuit'
                                break
                            case 0x5:
                                value = 'Failure with some sensors'
                                break
                            case 0x6:
                                value = 'Failure with'
                                break
                        }
                        break

                    case 'st_transmission_warning':
                        switch (value) {
                            case 1:
                                value = 'Overheat'
                                break
                            case 3:
                                value = 'Critical Failure'
                                break
                            case 4:
                                value = 'No Failure'
                                break
                            case 5:
                                value = 'Limited Functionality'
                                break
                            case 6:
                                value = 'Drive to stop'
                                break
                            case 'E':
                                value = 'Not Available'
                                break
                            case 'F':
                                value = 'Default'
                                break
                        }
                        break

                    // @TODO: Здесь нужно присваивать (и выводить в компонентах) value_text вместо value
                    case 'status':
                        switch (value) {
                            case 0:
                                value = 'Deep sleep'
                                break
                            case 1:
                                value = 'Sleep'
                                break
                            case 2:
                                value = 'Standby'
                                break
                            case 3:
                                value = 'Ignition'
                                break
                            case 4:
                                value = 'Drive'
                                break
                            case 5:
                                value = 'Remote start'
                                break
                            case 6:
                                value = 'Service Mode'
                                break
                            case 8:
                                value = 'Preheating'
                                break
                            case 9:
                                value = 'Comfort'
                                break
                            case 10:
                                value = 'Multimedia'
                                break
                            case 15:
                                value = 'Unknown'
                                break
                            case 16:
                                value = 'Shutdown'
                                break
                            case 17:
                                value = 'AfterRun'
                                break
                            case 18:
                                value = 'E Mode'
                                break
                            case 19:
                                value = 'Hybrid Mode'
                                break
                            case 20:
                                value = 'Secure State'
                                break
                            case 21:
                                value = 'Charge'
                                break
                            default:
                                value = 'Reserve'
                                break
                        }
                        break

                    case 'ERAG_failure_status':
                        switch (value) {
                            case 0:
                                value = 'No failure'
                                break
                            case 1:
                                value = 'Unavailable microphone'
                                break
                            case 2:
                                value = 'Unavailable speaker'
                                break
                            case 3:
                                value = 'Unavailable SOS button'
                                break
                            case 4:
                                value = 'Unavailable GPS'
                                break
                            case 5:
                                value = 'Unavailable GSM'
                                break
                            case 6:
                                value = 'Full Failure'
                                break
                        }
                        break

                    case 'HV_system_failure':
                        switch (value) {
                            case 0:
                                value = 'No failure'
                                break
                            case 1:
                                value = 'No energy source available'
                                break
                            case 2:
                                value = 'Warning'
                                break
                            case 3:
                                value = 'Error'
                                break
                        }
                        break

                    case 'LTC_coolant_lvl':
                        switch (value) {
                            case 0:
                                value = 'Normal'
                                break
                            case 1:
                                value = 'Low'
                                break
                        }
                        break

                    case 'engine_oil_lvInd':
                        switch (value) {
                            case 0:
                                value_text = 'LEVEL_NORMAL'
                                break
                            case 1:
                                value_text = 'LEVEL_LOW'
                                break
                            case 2:
                                value_text = 'LEVEL_HIGH'
                                break
                            case 3:
                                value_text = 'LEVEL_CRITICAL_LOW'
                                break
                        }
                        break

                    case 'oil_pressure_warning':
                        switch (value) {
                            case 0:
                                value = 'Normal'
                                break
                            case 1:
                                value = 'Low'
                                break
                        }
                        break

                    case 'temperature_outside':
                        // console.log(value, 'TO')
                        value = Number(value).toFixed()
                        break

                    // 'front_inside_temperature' больше не актульно
                    // 'back_inside_temperature' - температура в салоне
                    // case 'front_inside_temperature':
                    case 'back_inside_temperature':
                        value = value.toFixed(1)
                        break

                    // Старые стейты температуры климат-контроля
                    // Вероятно, можно удалить
                    // case 'front_left_temperature':
                    // case 'front_right_temperature':
                    // case 'back_left_temperature':
                    // case 'back_right_temperature':
                    //     value = String(value.toFixed(1)).split('.')
                    //     break

                    case 'door_hood':
                        switch (value) {
                            case 0:
                                value_text = getTranslate.value.STATE_CLOSED
                                break
                            case 1:
                                value_text = getTranslate.value.STATE_OPEN
                                break
                        }
                        break

                    case 'door_front_left':
                    case 'door_front_right':
                    case 'door_back_left':
                    case 'door_back_right':
                        switch (value) {
                            case 0:
                                value_text = getTranslate.value.STATE_CLOSED
                                break
                            case 1:
                                value_text = getTranslate.value.STATE_OPEN
                                break
                        }
                        break

                    case 'is_locked':
                        switch (value) {
                            case 1:
                                value_text = getTranslate.value.STATE_OPEN
                                break
                            case 2:
                            case 3:
                            case 4:
                                value_text = getTranslate.value.STATE_CLOSED
                                break
                        }
                        break

                    case 'total_mileage':
                        value = Number(value).toFixed(1)
                        break

                    case 'total_mileage_am':
                        value = Number(value).toFixed(1)
                        break

                    case 'fuel':
                        value = value.toFixed(1)
                        break

                    case 'fuel_consumption':
                        value = value !== 0 ? value.toFixed(1) : null
                        break

                    case 'door_trunk':
                        switch (value) {
                            case 1:
                                value_text = getTranslate.value.STATE_HALF_OPEN
                                break
                            case 2:
                                value_text = getTranslate.value.STATE_OPEN
                                break
                            case 3:
                                value_text = getTranslate.value.STATE_CLOSED
                        }
                        break

                    case 'epb_status':
                        switch (value) {
                            case 0:
                                value = 'OFF'
                                break
                            case 1:
                                value = 'ON'
                                break
                            case 2:
                                value = 'Dynamic'
                                break
                            case 3:
                                value = 'Failure Indication'
                        }
                        break

                    case 'battery_voltage':
                        value = value.toFixed(1)
                        break

                    case 'wheel_front_left_pressure':
                        value = value.toFixed(1)
                        break

                    case 'wheel_front_right_pressure':
                        value = value.toFixed(1)
                        break

                    case 'wheel_back_left_pressure':
                        value = value.toFixed(1)
                        break

                    case 'wheel_back_right_pressure':
                        value = value.toFixed(1)
                        break

                    case 'engine_rev':
                        value = Number(value).toFixed()
                        break

                    case 'door_front_left_closed':
                    case 'door_front_right_closed':
                    case 'door_back_left_closed':
                    case 'door_back_right_closed':
                        switch (value) {
                            case 0:
                                value = getTranslate.value.STATE_OPEN
                                break
                            case 1:
                                value = getTranslate.value.STATE_CLOSED
                                break
                            case 2:
                                value = getTranslate.value.STATE_ERROR
                                break
                        }
                        break

                    case 'ride_mileage':
                        value = value.toFixed(1)
                        break

                    case 'ride_fuel_consumption':
                        value = value !== 0 ? value.toFixed(1) : null
                        break

                    case 'ride_time':
                        value = value ? parseMinutes(value, 'sec') : null
                        break

                    case 'wheel_front_left_status':
                    case 'wheel_front_right_status':
                    case 'wheel_back_left_status':
                    case 'wheel_back_right_status':
                        switch (value) {
                            case 1:
                                value_text = 'STATE_WHEEL_PRESSURE_STATUS_HIGH'
                                break
                            case 2:
                                value_text = 'STATE_WHEEL_PRESSURE_STATUS_NORMAL'
                                break
                            case 3:
                                value_text = 'STATE_WHEEL_PRESSURE_STATUS_LOW'
                                break
                            case 4:
                                value_text = 'STATE_WHEEL_PRESSURE_STATUS_CRITICAL'
                                break
                            case 6:
                                value_text = 'STATE_WHEEL_PRESSURE_STATUS_ERROR'
                                break
                            default:
                                value_text = ''
                                break
                        }
                        break

                    case 'coolant_fluid':
                        switch (value) {
                            case 0:
                                value_text = 'STATE_COOLANT_FLUID_NORMAL'
                                break
                            case 1:
                                value_text = 'STATE_COOLANT_FLUID_LOW'
                                break
                        }
                        break

                    case 'online':
                        switch (value) {
                            case 0:
                                value_text = getTranslate.value.STATE_OFFLINE
                                carOnline.value.text = 'OFFLINE'
                                carOnline.value.status = 0

                                if (carStateItem.updateAt) {
                                    carState.value.last_online.value = new Date(
                                        carStateItem.updateAt * 1000
                                    ).toLocaleString()
                                } else {
                                    carState.value.last_online.value = null
                                }

                                break

                            case 1:
                                value_text = getTranslate.value.STATE_ONLINE
                                carOnline.value.text = 'ONLINE'
                                carOnline.value.status = 1

                                carState.value.last_online.value = getTranslate.value.STATE_ONLINE
                                break

                            case 2:
                                value_text = getTranslate.value.STATE_ONLINE
                                carOnline.value.text = 'ONLINE'
                                carOnline.value.status = 2

                                carState.value.last_online.value = getTranslate.value.STATE_ONLINE
                                break
                        }

                        break

                    case 'washer_fluid':
                        switch (value) {
                            case 0:
                                value_text = 'Normal'
                                break
                            case 1:
                                value_text = 'Low level'
                                break
                        }
                        break

                    case 'battery_status':
                        switch (value) {
                            case 0:
                                value_text = 'Normal'
                                break
                            case 1:
                                value_text = 'Low SOC'
                                break
                        }
                        break

                    case 'battery12VStatus':
                        switch (value) {
                            case 0:
                                value_text = 'STATE_BATTERY_12V_STATUS_FULL'
                                break
                            case 1:
                                value_text = 'STATE_BATTERY_12V_STATUS_NORMAL'
                                break
                            case 2:
                                value_text = 'STATE_BATTERY_12V_STATUS_REQUEST_CHARGE'
                                break
                            case 3:
                                value_text = 'STATE_BATTERY_12V_STATUS_DISCHARGE'
                                break
                            case 4:
                                value_text = 'STATE_BATTERY_12V_STATUS_LOW_SOC'
                                break
                            case 5:
                                value_text = 'STATE_BATTERY_12V_STATUS_LOW_VOLT'
                                break
                        }
                        break

                    case 'gear_position':
                        switch (value) {
                            case 1:
                                value = 'P'
                                break
                            case 2:
                                value = 'R'
                                break
                            case 3:
                                value = 'N'
                                break
                            case 4:
                                value = 'D'
                                break
                        }
                        break

                    case 'oil_level':
                        value = Math.round(value)
                        break

                    case 'engine_on':
                    case 'engine_off':
                    case 'start_moving':
                    case 'stop_moving':
                    case 'last_diagnostics_time':
                    case 'last_navigation_time':
                    case 'last_can_param_time':
                        value = new Date(carStateItem.updateAt * 1000).toLocaleString()
                        break

                    case 'window_fully_closed_FL':
                    case 'window_fully_closed_FR':
                    case 'window_fully_closed_RL':
                    case 'window_fully_closed_RR':
                        switch (value) {
                            case 0:
                                value_text = getTranslate.value.STATE_NOT_CLOSED
                                break
                            case 1:
                                value_text = getTranslate.value.STATE_CLOSED
                                break
                        }
                        break

                    // Данные компонента ASConnectionType [НАЧАЛО]
                    case 'received_signal_strength_indicator':
                        connectionType.value[msg.car]
                            ? (connectionType.value[msg.car].level = value)
                            : (connectionType.value[msg.car] = { level: value })
                        break

                    case 'mobile_network_type_indicator':
                        connectionType.value[msg.car]
                            ? (connectionType.value[msg.car].type = value)
                            : (connectionType.value[msg.car] = { type: value })
                        break
                    // Данные компонента ASConnectionType [КОНЕЦ]

                    // case 'vehicle_secure_lock_state':
                    //     switch(value) {
                    //         case 0: value = 'Unsecure'
                    //             break
                    //         case 1: value = 'Secure'
                    //             break
                    //     }
                    //     break

                    case 'vas_activation':
                        switch (value) {
                            case 0:
                                value_text = 'STATE_VAS_INACTIVE'
                                break
                            case 1:
                                value_text = 'STATE_VAS_ACTIVE'
                                break
                        }
                        break

                    case 'sdm_uptime':
                        value = parseMinutes(value)
                        break

                    case 'total_avg_speed_am':
                        value = value.toFixed(1)
                        break

                    case 'total_mins_am':
                        value = parseMinutes(value)
                        break

                    case 'ocu_fl_stat':
                    case 'ocu_fr_stat':
                    case 'ocu_rl_stat':
                    case 'ocu_rr_stat':
                        if (![0, 1, 2, 3, 4, 5].includes(Number(value))) {
                            value = null
                        }
                        break

                    case 'energy_consumed':
                        value = Number(value)
                        break

                    /**
                     *
                     * CCU - Climate Control Unit
                     * Блок управления климаттический установкой
                     *
                     * Для ЕМП 1.0:
                     * - CAN_UMP10_CCU_Stat1_Struct
                     * - CAN_UMP10_CCU_Stat2_Struct
                     * - CAN_UMP10_CCU_Stat3_Struct
                     *
                     * Для ЕМП 1.5:
                     * - CAN_CCU_Stat1_Struct
                     * - CAN_CCU_Stat2_Struct
                     * - CAN_CCU_Stat3_Struct
                     *
                     */
                    // case 'CAN_CCU_Stat1_Struct':
                    //     carState.value.front_left_temperature.value = Number(value.frontLeftZone.temp)
                    //     carState.value.front_right_temperature.value = Number(value.frontRightZone.temp)
                    //     carState.value.back_left_temperature.value = Number(value.rearLeftZone.temp)
                    //     carState.value.back_right_temperature.value = Number(value.rearRightZone.temp)
                    //     break

                    case 'charging_status':
                        switch (value) {
                            case 0:
                                value_text = 'STATE_NO_CHARGING'
                                break
                            case 1:
                                value_text = 'STATE_CHARGING_IN_PROGRESS'
                                break
                            case 2:
                                value_text = 'STATE_CHARGING_DONE'
                                break
                            case 3:
                                value_text = 'STATE_CHARGING_SUSPEND_VEHICLE'
                                break
                            case 4:
                                value_text = 'STATE_CHARGING_SUSPEND_CHARGER'
                                break
                            case 5:
                                value_text = 'STATE_CHARGING_INIT'
                                break
                            case 8:
                                value_text = 'STATE_CHARGING_V2L_IDLE'
                                break
                            case 9:
                                value_text = 'STATE_CHARGING_V2L_ACTIVE'
                                break
                            default:
                                value_text = ''
                                break
                        }
                        break

                    case 'reduce_charging_status':
                        switch (value) {
                            case 0:
                                value_text = 'STATE_NOT_REDUCED'
                                break
                            case 1:
                                value_text = 'STATE_REDUCED'
                                break
                        }
                        break

                    case 'charger_input_current_ma':
                        value = (value / 1000).toFixed(1)
                        break

                    case 'total_charging_power_wh':
                        value = (value / 1000).toFixed(1)
                        break

                    case 'charger_input_power_w':
                        value = (value / 1000).toFixed(1)
                        break

                    case 'charging_duration_s':
                        value = parseMinutes(value, 'sec')
                        break

                    case 'remaining_charging_time_s':
                        value = parseMinutes(value, 'sec')
                        break
                }
            } else {
                value = null
                value_text = ''
            }

            if (carState.value[carStateItem.key]) {
                carState.value[carStateItem.key].value = value
                carState.value[carStateItem.key].value_text = value_text
                cars.value[msg.car][carStateItem.key] = { value, value_text }
            } else {
                // console.log(
                //     'Обнаружен неизвестный параметр: ',
                //     carStateItem.key || 'нет параметра key',
                //     carStateItem.value
                // )
                carState.value[carStateItem.key] = {
                    value: value
                }
            }
        }

        point.value = msg
    }

    // Проверка актуальности carState ВРУЧНУЮ
    function checkCarStates(referenceArr) {
        const carStateArr = Object.keys(carState.value)

        const diff = (arr1, arr2) => {
            return arr1.filter(item => !arr2.includes(item))
        }

        console.log('needAdd: ', diff(referenceArr, carStateArr))
        console.log('needDelete: ', diff(carStateArr, referenceArr))
    }

    function clearStates() {
        for (let item in carState.value) {
            carState.value[item].value = null
            carState.value[item].value_text = '–'
        }
    }

    return {
        point,
        cars,
        carState,
        carStateMsg,
        carOnline,
        connectionType,
        latestPoint,
        latestPointProcess,
        latestPointMsg,
        readLatestPoint,
        readPoints,
        checkCarStates,
        clearStates
    }
})
